/**
 * 跟區域語系有關的驗證函式
 *
 * validateWhiteList: 檢查目前的網址路徑是否在白名單中，在白名單內的頁面可以不用驗證區域語系
 * @param path: 目前的網址路徑
 * @returns Boolean（驗證通過，在白名單內的話回傳 True）
 *
 * validateSupportRegionLocale: 根據 regionCode 判斷目前的 locale 是否支援該區域的語系
 * @param [IPayload] path: 目前的網址路徑
 * @param [IPayload] locale: 目前的語系
 * @param [IPayload] regions: 可用的地區列表
 * @param [IPayload] regionCode: 目前的地區代碼
 * @returns Boolean（區域語系驗證通過回傳 True）
 */

import type { IRegion } from '@/assets/types/api/Common';

interface IPayload {
  path: string;
  locale: string | null;
  regions: IRegion[];
  regionCode: EnumRegion | null;
}

export function validateRegionLocale() {
  const validateWhiteList = (path: string): boolean => {
    const toLowerPath = path.toLowerCase();
    const whiteList = ['/internalcrm/shippingorder/delivery'];
    return whiteList.some((item) => toLowerPath.includes(item));
  };

  const validateSupportRegionLocale = (payload: IPayload): boolean => {
    const { path, locale, regions, regionCode } = payload;

    if (validateWhiteList(path)) {
      return true;
    }

    if (regionCode) {
      const regionItem = regions.find((item) => item.regionCode === regionCode);
      if (regionItem) {
        return regionItem.websites.some((item) => item.code === locale);
      }
      return false;
    }
    return false;
  };

  return { validateWhiteList, validateSupportRegionLocale };
}
